import React from 'react';
interface ShareCardProps {
  verse: string;
  reference: string;
  prayer?: string;
}
export function ShareCard({
  verse,
  reference,
  prayer
}: ShareCardProps) {
  return <div className="bg-gradient-to-br from-sky-100 via-purple-50 to-pink-100 rounded-2xl p-8 shadow-xl max-w-md mx-auto" data-id="element-221">
      {/* Decorative Element */}
      <div className="flex justify-center mb-6" data-id="element-222">
        <div className="w-12 h-12 bg-gradient-to-br from-sky-400 to-purple-400 rounded-full flex items-center justify-center shadow-lg" data-id="element-223">
          <span className="text-white text-2xl" data-id="element-224">✦</span>
        </div>
      </div>

      {/* Verse */}
      <blockquote className="mb-6" data-id="element-225">
        <p className="scripture-text text-slate-800 text-lg leading-relaxed text-center mb-3" data-id="element-226">
          "{verse}"
        </p>
        <cite className="block text-center text-slate-600 not-italic font-medium" data-id="element-227">
          — {reference}
        </cite>
      </blockquote>

      {/* Prayer (if included) */}
      {prayer && <div className="border-t border-slate-200 pt-6" data-id="element-228">
          <p className="text-sm text-slate-700 leading-relaxed italic text-center" data-id="element-229">
            {prayer}
          </p>
        </div>}

      {/* Branding */}
      <div className="mt-8 text-center" data-id="element-230">
        <p className="text-xs text-slate-500" data-id="element-231">Shared from SoulLift</p>
      </div>
    </div>;
}